import {newModalStore} from "@/store/helpers/modal-helper";
import {MmfVuexStoreHelper} from "./helpers/MmfVuexStoreHelper";

let uploadModal = new MmfVuexStoreHelper(newModalStore())
    .namespaced()
    .withStates({
        data: null,
        fileProcessedResponse: null,
        errorArray: [],
        modalTitle: "Upload Rules",
        fileLabel: "Rules File:",
        fileInputLabel: "Choose file",
        buttonUpload: "Process File",
        cancelButtons: [ {
            id: 'cancel',
            label: 'lbl.basic.close'
        }],
        confirmButtons: [ {
            id: 'confirm',
            label: 'lbl.basic.confirm'
        }]
    })
    .withMutations({
        setFileProcessedResponse(state, value){
            state.fileProcessedResponse = value
        },
        setData(state, value){
            state.data = value
        },
        setErrorArray(state, value){
            state.errorArray = value
        }
    })
    .withActions({
        cancelModal(context) {
            context.commit("setIsVisible", false)
            context.commit("setFileProcessedResponse", null)
        },
        processFile(context, file) {
            if (!file) {
                //TODO send error
                return;
            }
            let formData = new FormData();
            formData.append("excel", file);
            var url = process.env.VUE_APP_ADM_API_URL + "adm-service/adm/integrationMessageConfig/validateExcel"
            context.dispatch("api/postMultipart", 
            {   url , 
                data: formData
            }, {root: true})
            .then(function(response) {
                if (response.data.errors.length == 0) {
                    context.commit("setFileProcessedResponse", true);
                    context.commit("setData", response.data.messageDataConversions)
                }
                else {
                    context.commit("setFileProcessedResponse", false);
                    context.commit("setErrorArray", response.data.errors);
                }
            })
        }
    })
    .buildStore()

export default uploadModal
